<!--面板组件-->

<template>
  <div class="panel" @click="$emit('on-panel-click')">
    <slot name="title"></slot>
    <slot name="infos"></slot>
    <img class="icon-right" src="@/assets/pc/icon_arrow down.svg" alt="">
  </div>
</template>

<script>
  export default {
    name: 'Panel',
    props: {}
  }
</script>

<style lang="scss" scoped>
  .panel {
    position: relative;
    width: 776px;
    height: 156px;
    border: 1px solid #EAEEF3;
    border-radius: 8px;
    padding: 28px 22px;
    cursor: pointer;

    .title {
      font-family: Nunito-SemiBold;
      font-size: 24px;
      color: #3E8EDE;
      letter-spacing: 0.14px;
    }

    .infos {
      width: 670px;
      font-family: Nunito-Regular;
      font-size: 16px;
      color: #A3A3A3;
      letter-spacing: 0.08px;
      line-height: 30px;
      margin-top: 10px;
    }

    .icon-right {
      width: 50px;
      position: absolute;
      right: 10px;
      top:50%;
      transform: translateY(-50%) rotate(-90deg);
    }
  }
</style>
